import {
  AfterViewInit,
  Directive,
  effect,
  ElementRef,
  inject,
  input,
} from '@angular/core';
import { PermissionsService } from '../../../core/common/services/permissions/permissions.service';
import { Permission } from '../../../core/common/models/permission.model';

@Directive({
  selector: '[libPermissions]',
})
export class PermissionsDirective implements AfterViewInit {
  permissionsService = inject(PermissionsService);
  private element = inject(ElementRef);

  featurePermissions = input<readonly string[]>([]);
  userPermissions = input<Permission[]>([]);

  private isHidden = false;

  constructor() {
    effect(() => {
      this.updateView();
    });
  }

  ngAfterViewInit() {
    this.updateView();
  }

  private updateView() {
    if (
      this.permissionsService.checkPermission(
        this.featurePermissions(),
        this.userPermissions()
      )
    ) {
      //show
      if (this.isHidden) {
        this.element.nativeElement.style.display = 'block';
        this.isHidden = false;
      }
    } else {
      //hide
      this.isHidden = true;
      this.element.nativeElement.style.display = 'none';
    }
  }
}
